import * as actionTypes from "./actionTypes";

const initialState: UserState = {
  user: {
    id: 0,  
    name:"", 
    token:""
  }
};

const reducer = (
  state: UserState = initialState,
  action: UserAction
): UserState => {
  switch (action.type) {
    case actionTypes.GET_USER:    
      return state;

    case actionTypes.SET_USER:
      const newUser: IUser = {
        id: action.user.id, 
        name: action.user.name,
        token: action.user.token
      };
      return {
        ...state,
        user: newUser
      };
    case actionTypes.REMOVE_USER:
      const updatedUser: IUser = state.user;

      return {
        ...state,
        user: updatedUser
      };
  }
  return state;
};

export default reducer;
